import { apiClient } from '@/lib/apiClient';
import type {
  AuditoriaPeriodo,
  RelatorioConciliacao,
  AjusteHistorico,
  AjustarDivergenciaDto,
  FecharConciliacaoDto,
} from '../types/pdv.types';

const BASE = '/api/pdv/conciliacao';

export const conciliacaoService = {
  async auditarPeriodo(
    empresaId: number,
    dtInicio: string,
    dtFim: string,
  ): Promise<AuditoriaPeriodo> {
    const { data } = await apiClient.get<AuditoriaPeriodo>(`${BASE}/auditoria`, {
      params: { empresaId, dtInicio, dtFim },
    });
    return data;
  },

  async gerarRelatorio(
    empresaId: number,
    dtInicio: string,
    dtFim: string,
    turnoId?: number,
  ): Promise<RelatorioConciliacao> {
    const { data } = await apiClient.get<RelatorioConciliacao>(`${BASE}/relatorio`, {
      params: { empresaId, dtInicio, dtFim, turnoId },
    });
    return data;
  },

  async ajustarDivergencia(
    turnoId: number,
    dto: AjustarDivergenciaDto,
  ): Promise<AjusteHistorico> {
    const { data } = await apiClient.post<AjusteHistorico>(
      `${BASE}/turno/${turnoId}/ajuste`,
      dto,
    );
    return data;
  },

  async fecharConciliacao(
    turnoId: number,
    dto: FecharConciliacaoDto,
  ): Promise<{ mensagem: string }> {
    const { data } = await apiClient.post<{ mensagem: string }>(
      `${BASE}/turno/${turnoId}/fechar`,
      dto,
    );
    return data;
  },

  async obterHistoricoAjustes(turnoId: number): Promise<AjusteHistorico[]> {
    const { data } = await apiClient.get<AjusteHistorico[]>(
      `${BASE}/turno/${turnoId}/historico-ajustes`,
    );
    return data;
  },
};
